"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocationType = void 0;
exports["default"] = Auth;
exports.identifyClient = exports.getClientIdWithIdentifier = exports.generateCodeVerifier = exports.generateCodeChallange = void 0;
var _oidcClient = _interopRequireWildcard(require("oidc-client/lib/oidc-client"));
var _jwtDecode = _interopRequireDefault(require("jwt-decode"));
var _sha = _interopRequireDefault(require("crypto-js/sha256"));
var _encBase = _interopRequireDefault(require("crypto-js/enc-base64"));
var _events = _interopRequireDefault(require("./events"));
var _random = _interopRequireDefault(require("./random"));
var _storage = _interopRequireWildcard(require("./storage"));
var _activityTimeout = _interopRequireDefault(require("./activity-timeout"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t8 in e) "default" !== _t8 && {}.hasOwnProperty.call(e, _t8) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t8)) && (i.get || i.set) ? o(f, _t8, i) : f[_t8] = e[_t8]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var storage = new _storage["default"](_storage.STORAGE_TYPE_LOCAL);
var ERROR_MESSAGES_TO_IGNORE = ['End-User authentication is required'];
function Auth(options) {
  var location = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window.location;
  var basePathname = options.basePathname || '';
  var isLocalhost = location.origin.indexOf('://localhost') >= 0;
  var events = {
    signInNeeded: new _events["default"](),
    signIn: new _events["default"](),
    signOut: new _events["default"](),
    stateChange: new _events["default"](),
    setLocation: new _events["default"](),
    signInError: new _events["default"](),
    signOutError: new _events["default"](),
    sessionExpired: new _events["default"](),
    sessionExpiring: new _events["default"](),
    identityAssumed: new _events["default"](),
    identityRestored: new _events["default"]()
  };
  options = _objectSpread({
    basePathname: basePathname,
    clientId: options.companyId ? "".concat(location.origin).concat(basePathname, "#").concat(options.companyId) : "".concat(location.origin).concat(basePathname),
    redirectUri: "".concat(location.origin).concat(basePathname, "/oidc_signin"),
    postLogoutRedirectUri: "".concat(location.origin).concat(basePathname, "/oidc_signout"),
    silentRedirectUri: "".concat(location.origin).concat(basePathname, "/oidc_renew"),
    popup: false,
    popupRedirectUri: "".concat(location.origin).concat(basePathname, "/oidc_signin"),
    popupWindowFeatures: 'location=no,toolbar=no,width=500,height=800,left=100,top=100',
    popupWindowTarget: '_blank',
    responseType: 'code',
    responseMode: 'query',
    scope: "openid profile company permissions email recovery address phone".concat(options.offlineAccess ? ' offline_access' : ''),
    filterProtocolClaims: true,
    automaticSilentRenew: false,
    // handle this with an event
    revokeAccessTokenOnSignOut: true,
    loadUserInfo: true,
    clockSkew: 600,
    monitorAccessTokenExpiration: true,
    checkRecoveryMethods: true,
    enableActivityTimeout: false,
    activityTimeoutInMinutes: 60,
    activityPromptInMinutes: 50
  }, options || {});

  // create a storate key to track where to return
  var returnToKey = "bridge.returnTo.".concat(options.clientId);
  var sessionExpiredKey = "bridge.sessionExpired.".concat(options.clientId);
  var referrer = document ? document.referrer : null;
  if (referrer) {
    options.extraQueryParams = _objectSpread(_objectSpread({}, options.extraQueryParams || {}), {}, {
      referrer: encodeURIComponent(referrer.split('?')[0])
    });
  }

  // check to see if a sso_token was passed along
  var ssoToken = getSSOToken();
  if (ssoToken) {
    options.extraQueryParams = _objectSpread(_objectSpread({}, options.extraQueryParams || {}), {}, {
      ssoToken: ssoToken
    });
  }

  // legacy support for company-setup
  if (options.clientId === 'admin') {
    options.clientId = "admin:".concat(location.origin).concat(basePathname);
  }

  // make trace functions
  function getTraceLocation() {
    if (options.debugLocation) {
      return " location: ".concat(window.location.href);
    }
    return '';
  }
  function traceStart(name) {
    if (options.debug === true || options.debug === undefined && isLocalhost) {
      console.group();
      console.debug("".concat(name).concat(getTraceLocation(), " entered"));
      return {
        end: function end(value) {
          console.debug("".concat(name).concat(getTraceLocation(), " exited"));
          console.groupEnd();
          return value;
        }
      };
    }
    // return an end function that does nothing
    return {
      end: function end(value) {
        return value;
      }
    };
  }

  // have oidc library log to the console.
  if (options.debug === true || options.debug === undefined && isLocalhost) {
    if (options.debugClient !== false) {
      _oidcClient["default"].Log.logger = console;
      _oidcClient["default"].Log.level = _oidcClient["default"].Log.DEBUG;
    }
  }
  // make sure uris are in lower case
  options.redirectUri = options.redirectUri.toLowerCase();
  options.postLogoutRedirectUri = options.postLogoutRedirectUri.toLowerCase();
  options.silentRedirectUri = options.silentRedirectUri.toLowerCase();
  var getRootUri = function getRootUri(includeQuery) {
    var trace = traceStart('getRootUri');
    if (includeQuery) {
      return trace.end("".concat("".concat(location.origin).concat(options.basePathname).toLowerCase()).concat(location.search));
    } else {
      return trace.end("".concat(location.origin).concat(options.basePathname).toLowerCase());
    }
  };
  function getCurrentUri(includeQuery) {
    var trace = traceStart('getCurrentUri');
    if (includeQuery) {
      return trace.end("".concat("".concat(location.origin).concat(location.pathname).toLowerCase()).concat(location.search));
    } else {
      return trace.end("".concat(location.origin).concat(location.pathname).toLowerCase());
    }
  }
  var isAuthUri = function isAuthUri(uri) {
    var trace = traceStart('isAuthUri');
    if (!uri) {
      uri = getCurrentUri();
    }
    return trace.end(uri === options.redirectUri || uri === options.postLogoutRedirectUri || uri === options.silentRedirectUri);
  };

  // if we are in an auth url; don't run the session check
  if (isAuthUri(getCurrentUri())) {
    options.monitorSession = false;
  }

  // create the user manager
  var userManager = new _oidcClient.UserManager(getUserManagerConfig(options));
  // remove stale state
  userManager.clearStaleState();
  var state = {};
  var cache = {};
  var getUser = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var trace, user;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            trace = traceStart('getUser');
            _context.n = 1;
            return userManager.getUser();
          case 1:
            user = _context.v;
            refreshState(user);
            return _context.a(2, trace.end(user));
        }
      }, _callee);
    }));
    return function getUser() {
      return _ref.apply(this, arguments);
    };
  }();
  var removeUser = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var trace;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            trace = traceStart('removeUser');
            _context2.n = 1;
            return userManager.removeUser();
          case 1:
            _context2.n = 2;
            return userManager.clearStaleState();
          case 2:
            refreshState(null);
            return _context2.a(2, trace.end());
        }
      }, _callee2);
    }));
    return function removeUser() {
      return _ref2.apply(this, arguments);
    };
  }();
  var refreshState = function refreshState(user, delegateUser) {
    var trace = traceStart('refreshState');
    var original = {
      access_token: user ? user.access_token : null,
      access_token_expires_at: user && user.expires_at ? new Date(user.expires_at * 1000) : null,
      refresh_token: user ? user.refresh_token : null,
      subject: user ? user.profile.sub : null,
      claims: {
        company_id: user ? user.profile.company_id : null,
        person_id: user ? user.profile.person_id : null,
        username: user ? user.profile.preferred_username : null,
        name: user ? user.profile.name : null,
        family_name: user ? user.profile.family_name : null,
        given_name: user ? user.profile.given_name : null,
        locale: user ? user.profile.locale : null,
        country: user ? user.profile.country : null,
        email: user ? user.profile.email : null,
        emails: user ? user.profile.emails : null,
        phone_number: user ? user.profile.phone_number : null,
        phone_numbers: user ? user.profile.phone_numbers : null,
        address: user ? user.profile.address : null,
        addresses: user ? user.profile.addresses : null,
        picture: user ? user.profile.picture : null,
        permissions: user ? user.profile.permissions : null,
        permittedCompanyIds: user ? user.profile.permitted_company_ids : null,
        attributes: user ? user.profile.attributes || {} : null
      }
    };
    var delegate = {
      access_token: delegateUser ? delegateUser.access_token : null,
      subject: delegateUser ? delegateUser.subject : null,
      claims: {
        company_id: delegateUser ? delegateUser.company_id : null,
        person_id: delegateUser ? delegateUser.person_id : null,
        username: delegateUser && user ? user.profile.preferred_username : null,
        name: delegateUser && user ? user.profile.name : null,
        family_name: delegateUser && user ? user.profile.family_name : null,
        given_name: delegateUser && user ? user.profile.given_name : null,
        locale: delegateUser && user ? user.profile.locale : null,
        country: delegateUser && user ? user.profile.country : null,
        email: delegateUser && user ? user.profile.email : null,
        emails: delegateUser && user ? user.profile.user : null,
        phone_number: delegateUser && user ? user.profile.phone_number : null,
        phone_numbers: delegateUser && user ? user.profile.phone_numbers : null,
        address: delegateUser && user ? user.profile.address : null,
        addresses: delegateUser && user ? user.profile.addresses : null,
        picture: delegateUser && user ? user.profile.picture : null,
        permissions: delegateUser ? delegateUser.permissions : null,
        permittedCompanyIds: delegateUser && user ? user.profile.permitted_company_ids : null,
        attributes: delegateUser ? {} : null
      }
    };
    var newState = {
      client_id: options.clientId,
      id_token: user ? user.id_token : null,
      session_id: user ? user.profile.sid : null,
      access_token: delegateUser ? delegate.access_token : original.access_token,
      access_token_expires_at: original.access_token_expires_at,
      refresh_token: original.refresh_token,
      subject: delegateUser ? delegate.subject : original.subject,
      claims: _objectSpread({}, delegateUser ? delegate.claims : original.claims),
      original: original,
      delegate: delegate,
      actor: delegateUser ? delegateUser.act : user ? user.profile.act : null
    };
    var didStateChange = JSON.stringify(state || {}) !== JSON.stringify(newState);
    if (didStateChange) {
      state = newState;
      events.stateChange.fire(state);
    }
    return trace.end();
  };
  var resume = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(session, signInOnResumeError) {
      var trace, result;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            trace = traceStart('resume');
            _context3.n = 1;
            return _signInOrResume(true, session, signInOnResumeError);
          case 1:
            result = _context3.v;
            return _context3.a(2, trace.end(result));
        }
      }, _callee3);
    }));
    return function resume(_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();
  var signIn = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var trace, result;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            trace = traceStart('signIn');
            _context4.n = 1;
            return _signInOrResume(false);
          case 1:
            result = _context4.v;
            return _context4.a(2, trace.end(result));
        }
      }, _callee4);
    }));
    return function signIn() {
      return _ref4.apply(this, arguments);
    };
  }();
  var _signInOrResume = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(isResuming, session, signInOnResumeError) {
      var trace, p, result, _p, _result, errorMessage, cancelRetry, _result2, _user$profile, _user$profile2, user, _t;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            trace = traceStart('signInOrResume'); // make sure sign in is only called once at a time
            // the auth process keeps some state and this can get mismatched if called multiple times
            if (!cache.signInOrResumePromise) {
              _context5.n = 2;
              break;
            }
            p = cache.signInOrResumePromise;
            _context5.n = 1;
            return Promise.resolve(p);
          case 1:
            result = _context5.v;
            return _context5.a(2, trace.end(result));
          case 2:
            _context5.p = 2;
            _p = signInOrResumeHelper(isResuming, session, signInOnResumeError);
            cache.signInOrResumePromise = _p;
            _context5.n = 3;
            return Promise.resolve(_p);
          case 3:
            _result = _context5.v;
            return _context5.a(2, trace.end(_result));
          case 4:
            _context5.p = 4;
            _t = _context5.v;
            // error messages from OpenId Connect are error_description, JS errors are message
            errorMessage = _t ? _t.error_description || _t.message : '';
            if (!(isResuming && signInOnResumeError)) {
              _context5.n = 9;
              break;
            }
            console.error(_t);
            cancelRetry = false;
            events.signInError.fire({
              error: _t,
              preventDefault: function preventDefault() {
                return cancelRetry = true;
              }
            });
            if (!cancelRetry) {
              _context5.n = 5;
              break;
            }
            return _context5.a(2, trace.end());
          case 5:
            _context5.n = 6;
            return userManager.removeUser();
          case 6:
            _context5.n = 7;
            return userManager.clearStaleState();
          case 7:
            _context5.n = 8;
            return _signInOrResume(false);
          case 8:
            _result2 = _context5.v;
            return _context5.a(2, trace.end(_result2));
          case 9:
            if (!ERROR_MESSAGES_TO_IGNORE.includes(errorMessage)) {
              _context5.n = 11;
              break;
            }
            _context5.n = 10;
            return getUser();
          case 10:
            user = _context5.v;
            if (user !== null && user !== void 0 && (_user$profile = user.profile) !== null && _user$profile !== void 0 && _user$profile.act && (user === null || user === void 0 || (_user$profile2 = user.profile) === null || _user$profile2 === void 0 || (_user$profile2 = _user$profile2.act) === null || _user$profile2 === void 0 ? void 0 : _user$profile2.type) === 'delegate') {
              signOut();
            }
            return _context5.a(2, trace.end());
          case 11:
            console.error(_t);
            events.signInError.fire({
              error: _t,
              preventDefault: function preventDefault() {
                return false;
              }
            });
          case 12:
            _context5.p = 12;
            cache.signInOrResumePromise = undefined;
            return _context5.f(12);
          case 13:
            return _context5.a(2, trace.end());
        }
      }, _callee5, null, [[2, 4, 12, 13]]);
    }));
    return function signInOrResume(_x3, _x4, _x5) {
      return _ref5.apply(this, arguments);
    };
  }();
  var signInOrResumeHelper = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(isResuming, session, signInOnResumeError) {
      var trace, user, uri, returnToUri, isSessionExpired, returnToType, source, shouldClearUserState, cancelSignIn, _t2;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            trace = traceStart('signInOrResumeHelper');
            user = null;
            uri = getCurrentUri(); // check if transferring here
            returnToUri = getCurrentUri(true);
            isSessionExpired = false;
            _t2 = uri;
            _context6.n = _t2 === options.redirectUri ? 1 : _t2 === options.popupRedirectUri ? 1 : _t2 === options.silentRedirectUri ? 6 : _t2 === options.postLogoutRedirectUri ? 9 : 15;
            break;
          case 1:
            if (!options.popup) {
              _context6.n = 3;
              break;
            }
            _context6.n = 2;
            return userManager.signinPopupCallback();
          case 2:
            _context6.n = 4;
            break;
          case 3:
            _context6.n = 4;
            return userManager.signinRedirectCallback();
          case 4:
            // restore the location
            returnToUri = storage.getItem(returnToKey);
            // if nothing was stored return to the current uri
            if (!returnToUri) {
              returnToUri = getRootUri(true);
            }
            // get the user
            _context6.n = 5;
            return getUser();
          case 5:
            user = _context6.v;
            // check to see if recovery methods are needed.
            returnToType = LocationType.SIGN_IN;
            if (user && user.profile) {
              if (options.checkRecoveryMethods && user.profile.recovery_methods_set === false && !(user.profile.act && user.profile.act.type === 'proxy')) {
                if (user.profile.recovery_methods_url) {
                  returnToType = LocationType.RECOVERY_METHODS;
                  source = encodeURIComponent(returnToUri);
                  if (source === 'undefined') {
                    source = encodeURIComponent(getRootUri(true));
                  }
                  returnToUri = "".concat(user.profile.recovery_methods_url, "?source=").concat(source);
                } else {
                  console.error('No Recovery Methods URL set');
                }
              } else if (user.profile.status === 'inactive') {
                if (user.profile.marketplace_login_url) {
                  returnToType = LocationType.MARKETPLACE_LOGIN;
                  returnToUri = user.profile.marketplace_login_url;
                } else {
                  console.error('No Marketplace Login URL set');
                }
              }
            }
            // set the location
            setLocation(returnToType, returnToUri);
            return _context6.a(3, 27);
          case 6:
            _context6.n = 7;
            return userManager.signinSilentCallback();
          case 7:
            _context6.n = 8;
            return getUser();
          case 8:
            user = _context6.v;
            return _context6.a(3, 27);
          case 9:
            if (!options.popup) {
              _context6.n = 11;
              break;
            }
            _context6.n = 10;
            return userManager.signoutPopupCallback();
          case 10:
            _context6.n = 12;
            break;
          case 11:
            _context6.n = 12;
            return userManager.signoutCallback();
          case 12:
            _context6.n = 13;
            return userManager.removeUser();
          case 13:
            _context6.n = 14;
            return userManager.clearStaleState();
          case 14:
            // fire the sign out event
            events.signOut.fire();
            // restore the location
            isSessionExpired = storage.getItem(sessionExpiredKey) === 'true';
            returnToUri = storage.getItem(returnToKey);
            if (!returnToUri) {
              returnToUri = getRootUri(true);
            }
            if (isSessionExpired) {
              sessionExpired();
            } else {
              // set the location
              setLocation(LocationType.SIGN_OUT, returnToUri);
            }
            return _context6.a(3, 27);
          case 15:
            // we are at a normal page
            shouldClearUserState = returnToUri.includes('clear=true'); // if coming from host transfer skip getting the current user from local storage
            // this will force it to go to id to use that session
            // this is to prevent any weirdness with delegates and going between sites
            if (!shouldClearUserState) {
              _context6.n = 16;
              break;
            }
            // if clearing user state, remove the clear param from returnUri or else when we
            // are redirected back after verifying the session, we will get into an infinite loop.
            returnToUri = returnToUri.replace('?clear=true', '').replace('&clear=true', '');
            window.history.replaceState({}, null, returnToUri);
            _context6.n = 18;
            break;
          case 16:
            _context6.n = 17;
            return getUser();
          case 17:
            user = _context6.v;
          case 18:
            // save the location
            storage.setItem(returnToKey, returnToUri);

            // if there is no user / is expired / or clear state flag set, try to sign in
            if (!(!shouldClearUserState && user && !user.expired && (!session || session.session_state === user.session_state))) {
              _context6.n = 19;
              break;
            }
            // restart the activity timer when coming back to the page
            if (options.enableActivityTimeout) {
              activityTimeout.recordActivity();
            }
            // if a user is signed in, fire the sign in event
            // so the component can update its state
            events.signIn.fire(state);
            return _context6.a(2);
          case 19:
            _context6.n = 20;
            return userManager.removeUser();
          case 20:
            _context6.n = 21;
            return userManager.clearStaleState();
          case 21:
            if (isResuming) {
              _context6.n = 22;
              break;
            }
            // allow canceling the sign in
            cancelSignIn = false;
            events.signInNeeded.fire({
              preventDefault: function preventDefault() {
                return cancelSignIn = true;
              }
            });
            if (!cancelSignIn) {
              _context6.n = 22;
              break;
            }
            return _context6.a(2);
          case 22:
            if (!options.popup) {
              _context6.n = 25;
              break;
            }
            _context6.n = 23;
            return userManager.signinPopup();
          case 23:
            _context6.n = 24;
            return getUser();
          case 24:
            user = _context6.v;
            // if there is no user or is expired, try to sign in
            if (user && !user.expired && (!session || session.session_state === user.session_state)) {
              // if a user is signed in, fire the sign in event
              // so the component can update its state
              events.signIn.fire(state);
            }
            _context6.n = 26;
            break;
          case 25:
            _context6.n = 26;
            return userManager.signinRedirect();
          case 26:
            return _context6.a(3, 27);
          case 27:
            return _context6.a(2, trace.end());
        }
      }, _callee6);
    }));
    return function signInOrResumeHelper(_x6, _x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }();
  var signOut = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(options) {
      var user, trace, p, _p2, result, _t3;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            if (!isAuthUri()) {
              _context7.n = 1;
              break;
            }
            return _context7.a(2);
          case 1:
            _context7.n = 2;
            return getUser();
          case 2:
            user = _context7.v;
            if (user) {
              _context7.n = 3;
              break;
            }
            return _context7.a(2);
          case 3:
            trace = traceStart('signOut'); // make sure sign out is only called once at a time
            // the auth process keeps some state and this can get mismatched if called multiple times
            if (!cache.signOutPromise) {
              _context7.n = 5;
              break;
            }
            p = cache.signOutPromise;
            _context7.n = 4;
            return Promise.resolve(p);
          case 4:
            return _context7.a(2, _context7.v);
          case 5:
            _context7.p = 5;
            _p2 = signOutHelper(options);
            cache.signInOrResumePromise = _p2;
            _context7.n = 6;
            return Promise.resolve(_p2);
          case 6:
            result = _context7.v;
            return _context7.a(2, trace.end(result));
          case 7:
            _context7.p = 7;
            _t3 = _context7.v;
            console.error(_t3);
            events.signOutError.fire({
              error: _t3
            });
          case 8:
            _context7.p = 8;
            cache.signOutPromise = undefined;
            return _context7.f(8);
          case 9:
            return _context7.a(2, trace.end());
        }
      }, _callee7, null, [[5, 7, 8, 9]]);
    }));
    return function signOut(_x9) {
      return _ref7.apply(this, arguments);
    };
  }();
  var signOutHelper = /*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      var signOutOptions,
        trace,
        returnToUri,
        _args8 = arguments;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.n) {
          case 0:
            signOutOptions = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : {};
            trace = traceStart('signOutHelper');
            returnToUri = signOutOptions.returnToUri;
            if (!returnToUri) {
              returnToUri = getCurrentUri(true);
            }
            if (signOutOptions.sessionExpired) {
              storage.setItem(sessionExpiredKey, 'true');
            } else {
              storage.setItem(sessionExpiredKey, '');
            }

            // save the location
            if (isAuthUri(returnToUri)) {
              returnToUri = storage.getItem(returnToKey);
              if (!returnToUri) {
                returnToUri = getRootUri(true);
              }
            }
            storage.setItem(returnToKey, returnToUri);
            if (activityTimeout) {
              activityTimeout.stopChecking();
            }
            if (!options.popup) {
              _context8.n = 2;
              break;
            }
            _context8.n = 1;
            return userManager.signoutPopup();
          case 1:
            _context8.n = 3;
            break;
          case 2:
            _context8.n = 3;
            return userManager.signoutRedirect();
          case 3:
            return _context8.a(2, trace.end());
        }
      }, _callee8);
    }));
    return function signOutHelper() {
      return _ref8.apply(this, arguments);
    };
  }();
  var hasSession = /*#__PURE__*/function () {
    var _ref9 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
      var trace, metadata, sessionEndpoint, query, storageToken, res, result, session, _t4;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            trace = traceStart('hasSession');
            _context9.p = 1;
            _context9.n = 2;
            return userManager.metadataService.getMetadata();
          case 2:
            metadata = _context9.v;
            sessionEndpoint = metadata.token_endpoint.replace('/token', '/session');
            query = '';
            _context9.n = 3;
            return userManager._userStore.get(userManager._userStoreKey);
          case 3:
            storageToken = _context9.v;
            if (storageToken && typeof storageToken === 'string') {
              query = "?id_token_hint=".concat(encodeURIComponent(JSON.parse(storageToken).id_token));
            }
            _context9.n = 4;
            return fetch("".concat(sessionEndpoint).concat(query), {
              credentials: 'include'
            });
          case 4:
            res = _context9.v;
            _context9.n = 5;
            return res.json();
          case 5:
            result = _context9.v;
            return _context9.a(2, trace.end(result.success));
          case 6:
            _context9.p = 6;
            _t4 = _context9.v;
            _context9.n = 7;
            return getSession();
          case 7:
            session = _context9.v;
            return _context9.a(2, trace.end(!!session));
        }
      }, _callee9, null, [[1, 6]]);
    }));
    return function hasSession() {
      return _ref9.apply(this, arguments);
    };
  }();
  var getSession = /*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
      var trace, result, _t5;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            trace = traceStart('getSession');
            _context0.p = 1;
            _context0.n = 2;
            return userManager.querySessionStatus();
          case 2:
            result = _context0.v;
            return _context0.a(2, trace.end(result));
          case 3:
            _context0.p = 3;
            _t5 = _context0.v;
            console.debug(_t5); // using to debug to keep it out of non-verbose logging
            return _context0.a(2, trace.end(null));
        }
      }, _callee0, null, [[1, 3]]);
    }));
    return function getSession() {
      return _ref0.apply(this, arguments);
    };
  }();
  function getSSOToken() {
    var trace = traceStart('getSSOToken');
    if (location.hash && location.hash.indexOf('sso_token=') > 0) {
      return trace.end(location.hash.substring(location.hash.indexOf('sso_token=')).split('=')[1]);
    }
    return trace.end(null);
  }
  var delegate = /*#__PURE__*/function () {
    var _ref1 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(company, subject) {
      var trace, metadata, user, subjectHeader, subjectPayload, subjectToken, response, data, payload, userInfoResponse, userInfo, _user;
      return _regenerator().w(function (_context1) {
        while (1) switch (_context1.n) {
          case 0:
            trace = traceStart('delegate');
            _context1.n = 1;
            return userManager.metadataService.getMetadata();
          case 1:
            metadata = _context1.v;
            _context1.n = 2;
            return userManager.getUser();
          case 2:
            user = _context1.v;
            if (!(metadata && state.original.access_token)) {
              _context1.n = 9;
              break;
            }
            subjectHeader = base64Encode(JSON.stringify({
              alg: 'none'
            }));
            subjectPayload = base64Encode(JSON.stringify({
              aud: options.clientId,
              cmp: company,
              sub: subject || state.original.subject,
              may_act: {
                aud: options.clientId,
                cmp: state.original.claims.company_id,
                sub: state.original.subject
              }
            }));
            subjectToken = "".concat(subjectHeader, ".").concat(subjectPayload, ".");
            _context1.n = 3;
            return fetch(metadata.token_endpoint, {
              method: 'POST',
              headers: {
                'content-type': 'application/x-www-form-urlencoded'
              },
              body: ["grant_type=".concat(encodeURIComponent('urn:ietf:params:oauth:grant-type:token-exchange')), "&subject_token=".concat(subjectToken), "&subject_token_type=".concat(encodeURIComponent('urn:ietf:params:oauth:token-type:jwt')), "&actor_token=".concat(state.original.access_token), "&actor_token_type=".concat(encodeURIComponent('urn:ietf:params:oauth:token-type:access_token')), "&client_id=".concat(encodeURIComponent(options.clientId))].join('')
            });
          case 3:
            response = _context1.v;
            _context1.n = 4;
            return response.json();
          case 4:
            data = _context1.v;
            if (!response.ok) {
              _context1.n = 7;
              break;
            }
            payload = (0, _jwtDecode["default"])(data.access_token); // get the user info for the delegate
            _context1.n = 5;
            return fetch(metadata.userinfo_endpoint, {
              headers: {
                authorization: "Bearer ".concat(data.access_token)
              }
            });
          case 5:
            userInfoResponse = _context1.v;
            _context1.n = 6;
            return userInfoResponse.json();
          case 6:
            userInfo = _context1.v;
            refreshState(user, {
              access_token: data.access_token,
              company_id: payload.cmp,
              subject: payload.sub,
              person_id: payload.person_id,
              permissions: userInfo.permissions || {},
              act: userInfo.act
            });
            return _context1.a(2, trace.end(state));
          case 7:
            _context1.n = 8;
            return userManager.getUser();
          case 8:
            _user = _context1.v;
            refreshState(_user);
            trace.end();
            throw new Error(data.message || data.error_description);
          case 9:
            return _context1.a(2);
        }
      }, _callee1);
    }));
    return function delegate(_x0, _x1) {
      return _ref1.apply(this, arguments);
    };
  }();
  var assumeIdentity = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10(_ref10) {
      var _ref10$location, location, subjectPersonId, subjectCompanyId, actorType, _ref10$postRestoreLoc, postRestoreLocation, target, _ref10$validator, validator, trace, body, query, apiDomain, hostParts, res, response, form, locationInput, _t6, _t7;
      return _regenerator().w(function (_context10) {
        while (1) switch (_context10.p = _context10.n) {
          case 0:
            _ref10$location = _ref10.location, location = _ref10$location === void 0 ? "".concat(window.location.origin, "/home/") : _ref10$location, subjectPersonId = _ref10.subjectPersonId, subjectCompanyId = _ref10.subjectCompanyId, actorType = _ref10.actorType, _ref10$postRestoreLoc = _ref10.postRestoreLocation, postRestoreLocation = _ref10$postRestoreLoc === void 0 ? "".concat(window.location.origin, "/profile/delegates/?restored=true") : _ref10$postRestoreLoc, target = _ref10.target, _ref10$validator = _ref10.validator, validator = _ref10$validator === void 0 ? 'permissions-manager' : _ref10$validator;
            trace = traceStart('assumeIdentity');
            body = {
              'client_id': state.original.claims.company_id,
              'actor_token': state.original.access_token,
              'actor_type': actorType,
              'subject_company_id': subjectCompanyId,
              'subject_account': subjectPersonId,
              'post_restore_location': postRestoreLocation
            };
            _context10.p = 1;
            query = validator ? new URLSearchParams({
              validator: validator
            }) : '';
            apiDomain = '';
            if (window.location.hostname !== 'localhost') {
              hostParts = window.location.hostname.split('.');
              hostParts.shift();
              apiDomain = "https://".concat(hostParts.join('.'));
            }
            _context10.n = 2;
            return fetch("".concat(window.location.hostname === 'localhost' ? 'https://qa.recognition-now.io' : apiDomain, "/api/v1/id/assume-identity?").concat(query), {
              method: 'POST',
              credentials: window.location.hostname === 'localhost' ? 'same-origin' : 'include',
              body: JSON.stringify(body),
              headers: {
                'content-type': 'application/json'
              }
            });
          case 2:
            res = _context10.v;
            if (!res.ok) {
              _context10.n = 4;
              break;
            }
            _context10.n = 3;
            return res.json();
          case 3:
            response = _context10.v;
            form = document.createElement('form');
            form.setAttribute('method', 'POST');
            form.setAttribute('action', response.sso_endpoint);
            form.setAttribute('target', target ? target : '_blank');
            locationInput = document.createElement('input');
            locationInput.setAttribute('type', 'hidden');
            locationInput.setAttribute('name', 'location');
            locationInput.setAttribute('value', location);
            form.appendChild(locationInput);
            document.body.appendChild(form);
            form.submit();
            _context10.n = 6;
            break;
          case 4:
            _t6 = console;
            _context10.n = 5;
            return res.json();
          case 5:
            _t6.log.call(_t6, _context10.v);
          case 6:
            _context10.n = 8;
            break;
          case 7:
            _context10.p = 7;
            _t7 = _context10.v;
            console.log(_t7);
          case 8:
            events.identityAssumed.fire();
            return _context10.a(2, trace.end());
        }
      }, _callee10, null, [[1, 7]]);
    }));
    return function assumeIdentity(_x10) {
      return _ref11.apply(this, arguments);
    };
  }();
  var restoreIdentity = /*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11() {
      var target,
        trace,
        metadata,
        form,
        clientIdInput,
        subjectTokenInput,
        _args11 = arguments;
      return _regenerator().w(function (_context11) {
        while (1) switch (_context11.n) {
          case 0:
            target = _args11.length > 0 && _args11[0] !== undefined ? _args11[0] : '_self';
            trace = traceStart('restoreIdentity');
            _context11.n = 1;
            return userManager.metadataService.getMetadata();
          case 1:
            metadata = _context11.v;
            if (metadata && state.original.access_token) {
              form = document.createElement('form');
              form.setAttribute('method', 'POST');
              form.setAttribute('action', metadata.token_endpoint.replace('/token', '/restore-identity'));
              form.setAttribute('target', target);
              clientIdInput = document.createElement('input');
              clientIdInput.setAttribute('type', 'hidden');
              clientIdInput.setAttribute('name', 'client_id');
              clientIdInput.setAttribute('value', options.clientId);
              form.appendChild(clientIdInput);
              subjectTokenInput = document.createElement('input');
              subjectTokenInput.setAttribute('type', 'hidden');
              subjectTokenInput.setAttribute('name', 'subject_token');
              subjectTokenInput.setAttribute('value', state.original.access_token);
              form.appendChild(subjectTokenInput);
              document.body.appendChild(form);
              form.submit();
            }
            events.identityRestored.fire();
            return _context11.a(2, trace.end());
        }
      }, _callee11);
    }));
    return function restoreIdentity() {
      return _ref12.apply(this, arguments);
    };
  }();
  var refresh = /*#__PURE__*/function () {
    var _ref13 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(authState) {
      var trace, refreshToken, metadata, response, data, hasDelegateToken, delegateCompany, delegateSubject;
      return _regenerator().w(function (_context12) {
        while (1) switch (_context12.n) {
          case 0:
            trace = traceStart('refresh');
            if (!authState) {
              authState = state;
            }
            refreshToken = authState.refresh_token;
            if (refreshToken) {
              _context12.n = 1;
              break;
            }
            return _context12.a(2);
          case 1:
            _context12.n = 2;
            return userManager.metadataService.getMetadata();
          case 2:
            metadata = _context12.v;
            _context12.n = 3;
            return fetch(metadata.token_endpoint, {
              method: 'POST',
              headers: {
                'content-type': 'application/x-www-form-urlencoded'
              },
              body: ['grant_type=refresh_token', "&refresh_token=".concat(refreshToken), "&client_id=".concat(encodeURIComponent(options.clientId)), options.clientSecret ? "&client_secret=".concat(encodeURIComponent(options.clientSecret)) : ''].join('')
            });
          case 3:
            response = _context12.v;
            _context12.n = 4;
            return response.json();
          case 4:
            data = _context12.v;
            if (!response.ok) {
              _context12.n = 6;
              break;
            }
            hasDelegateToken = !!authState.delegate.access_token;
            delegateCompany = authState.delegate.claims.company_id;
            delegateSubject = authState.delegate.subject;
            refreshState({
              id_token: authState.id_token,
              access_token: data.access_token,
              expires_at: Math.floor(new Date().valueOf() / 1000) + data.expires_in,
              refresh_token: data.refresh_token,
              profile: {
                sub: authState.original.subject,
                company_id: authState.original.claims.company_id,
                person_id: authState.original.claims.person_id,
                preferred_username: authState.original.claims.username,
                name: authState.original.claims.name,
                family_name: authState.original.claims.family_name,
                given_name: authState.original.claims.given_name,
                locale: authState.original.claims.locale,
                country: authState.original.claims.country,
                email: authState.original.claims.email,
                emails: authState.original.claims.emails,
                phone_number: authState.original.claims.phone_number,
                phone_numbers: authState.original.claims.phone_numbers,
                address: authState.original.claims.address,
                addresses: authState.original.claims.addresses,
                picture: authState.original.claims.picture,
                permissions: authState.original.claims.permissions,
                attributes: authState.original.claims.attributes,
                sid: authState.session_id,
                act: authState.original.act
              }
            });
            if (!hasDelegateToken) {
              _context12.n = 5;
              break;
            }
            _context12.n = 5;
            return delegate(delegateCompany, delegateSubject);
          case 5:
            return _context12.a(2, trace.end(data));
          case 6:
            trace.end();
            throw data;
          case 7:
            return _context12.a(2);
        }
      }, _callee12);
    }));
    return function refresh(_x11) {
      return _ref13.apply(this, arguments);
    };
  }();
  var renew = /*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13() {
      var trace, hasDelegateToken, delegateCompany, delegateSubject, user;
      return _regenerator().w(function (_context13) {
        while (1) switch (_context13.n) {
          case 0:
            trace = traceStart('renew');
            hasDelegateToken = !!state.delegate.access_token;
            delegateCompany = state.delegate.claims.company_id;
            delegateSubject = state.delegate.subject;
            _context13.n = 1;
            return userManager.signinSilent();
          case 1:
            if (!hasDelegateToken) {
              _context13.n = 2;
              break;
            }
            delegate(delegateCompany, delegateSubject);
            _context13.n = 4;
            break;
          case 2:
            _context13.n = 3;
            return userManager.getUser();
          case 3:
            user = _context13.v;
            refreshState(user);
          case 4:
            return _context13.a(2, trace.end());
        }
      }, _callee13);
    }));
    return function renew() {
      return _ref14.apply(this, arguments);
    };
  }();
  var setLocation = /*#__PURE__*/function () {
    var _ref15 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14(type, location) {
      var trace, cancel, args;
      return _regenerator().w(function (_context14) {
        while (1) switch (_context14.n) {
          case 0:
            trace = traceStart('setLocation');
            cancel = false;
            args = {
              type: type,
              location: location,
              preventDefault: function preventDefault() {
                return cancel = true;
              }
            };
            _context14.n = 1;
            return events.setLocation.fire(args);
          case 1:
            trace.end();
            if (!cancel) {
              window.location = args.location;
            }
          case 2:
            return _context14.a(2);
        }
      }, _callee14);
    }));
    return function setLocation(_x12, _x13) {
      return _ref15.apply(this, arguments);
    };
  }();
  refreshState();
  function sessionExpired() {
    var trace = traceStart('sessionExpired');
    var cancel = false;
    events.sessionExpired.fire({
      preventDefault: function preventDefault() {
        return cancel = true;
      }
    });
    if (cancel) {
      return trace.end();
    }
    trace.end();
    var userManager2 = new _oidcClient.UserManager(getUserManagerConfig(_objectSpread(_objectSpread({}, options), {}, {
      extraQueryParams: _objectSpread(_objectSpread({}, options.extraQueryParams || {}), {}, {
        sessionExpired: 'true'
      })
    })));
    userManager2.clearStaleState();
    userManager2.signinRedirect();
  }
  var getMetadata = /*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15() {
      var trace, result;
      return _regenerator().w(function (_context15) {
        while (1) switch (_context15.n) {
          case 0:
            trace = traceStart('getMetadata');
            _context15.n = 1;
            return userManager.metadataService.getMetadata();
          case 1:
            result = _context15.v;
            return _context15.a(2, trace.end(result));
        }
      }, _callee15);
    }));
    return function getMetadata() {
      return _ref16.apply(this, arguments);
    };
  }();

  //subscribe to expiring
  if (options.monitorAccessTokenExpiration) {
    userManager.events.addAccessTokenExpiring(renew);
    userManager.events.addAccessTokenExpired(sessionExpired);
  }

  // timeout sessions if there isn't any activity (if enabled)
  var activityTimeout = new _activityTimeout["default"](options);
  if (options.enableActivityTimeout) {
    if (activityTimeout.checkForTimeout()) {
      signOut({
        sessionExpired: false
      });
    }
    activityTimeout.startChecking(function (e) {
      events.sessionExpiring.fire(e);
    }, function (forced) {
      signOut({
        sessionExpired: !forced
      });
    });
  }

  //check for expired session when the tab comes into focus
  var handleVisibilityChange = /*#__PURE__*/function () {
    var _ref17 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee16() {
      var trace, expiration, session;
      return _regenerator().w(function (_context16) {
        while (1) switch (_context16.n) {
          case 0:
            trace = traceStart('handleVisibilityChange');
            if (document.hidden) {
              _context16.n = 4;
              break;
            }
            if (options.enableActivityTimeout) {
              // check to see if the session has expired from inactivity
              if (activityTimeout.checkForTimeout()) {
                signOut({
                  sessionExpired: true
                });
              } else {
                // restart the activity timer when coming back to the page
                activityTimeout.recordActivity();
              }
            }
            expiration = getExpiration(state.access_token);
            if (!(expiration && expiration.valueOf() < new Date().valueOf())) {
              _context16.n = 3;
              break;
            }
            _context16.n = 1;
            return getSession();
          case 1:
            session = _context16.v;
            if (!session) {
              _context16.n = 3;
              break;
            }
            _context16.n = 2;
            return renew();
          case 2:
            expiration = getExpiration(state.access_token);
          case 3:
            if (expiration && expiration.valueOf() < new Date().valueOf()) {
              sessionExpired();
            }
          case 4:
            return _context16.a(2, trace.end());
        }
      }, _callee16);
    }));
    return function handleVisibilityChange() {
      return _ref17.apply(this, arguments);
    };
  }();
  if (options.monitorAccessTokenExpiration) {
    document.addEventListener('visibilitychange', handleVisibilityChange, false);
  }
  var module = {
    getUser: getUser,
    removeUser: removeUser,
    refreshState: refreshState,
    getRootUri: getRootUri,
    getCurrentUri: getCurrentUri,
    isAuthUri: isAuthUri,
    signIn: signIn,
    signOut: signOut,
    resume: resume,
    getSession: getSession,
    hasSession: hasSession,
    getSSOToken: getSSOToken,
    delegate: delegate,
    assumeIdentity: assumeIdentity,
    restoreIdentity: restoreIdentity,
    renew: renew,
    refresh: refresh,
    setLocation: setLocation,
    getMetadata: getMetadata
  };
  return _objectSpread({
    get events() {
      return events;
    },
    get options() {
      return options;
    },
    get state() {
      return state;
    }
  }, module);
}
var getClientIdWithIdentifier = exports.getClientIdWithIdentifier = function getClientIdWithIdentifier(clientId, identifier) {
  if (!identifier) {
    return clientId;
  }
  return "".concat(clientId, "; identifier=").concat(identifier);
};
var identifyClient = exports.identifyClient = /*#__PURE__*/function () {
  var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee17(authority, clientId, clientSecret) {
    var response;
    return _regenerator().w(function (_context17) {
      while (1) switch (_context17.n) {
        case 0:
          if (clientId) {
            _context17.n = 1;
            break;
          }
          return _context17.a(2, {
            success: false
          });
        case 1:
          _context17.n = 2;
          return fetch("".concat(authority, "/clients/identify"), {
            method: 'POST',
            headers: {
              'content-type': 'application/x-www-form-urlencoded'
            },
            body: ["&client_id=".concat(encodeURIComponent(clientId)), clientSecret ? "&client_secret=".concat(encodeURIComponent(clientSecret)) : ''].join('')
          });
        case 2:
          response = _context17.v;
          _context17.n = 3;
          return response.json();
        case 3:
          return _context17.a(2, _context17.v);
      }
    }, _callee17);
  }));
  return function identifyClient(_x14, _x15, _x16) {
    return _ref18.apply(this, arguments);
  };
}();
var generateCodeVerifier = exports.generateCodeVerifier = /*#__PURE__*/function () {
  var _ref19 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee18() {
    return _regenerator().w(function (_context18) {
      while (1) switch (_context18.n) {
        case 0:
          return _context18.a(2, "".concat((0, _random["default"])()).concat((0, _random["default"])()).concat((0, _random["default"])()));
      }
    }, _callee18);
  }));
  return function generateCodeVerifier() {
    return _ref19.apply(this, arguments);
  };
}();
var generateCodeChallange = exports.generateCodeChallange = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee19(codeVerifier) {
    return _regenerator().w(function (_context19) {
      while (1) switch (_context19.n) {
        case 0:
          return _context19.a(2, _encBase["default"].stringify((0, _sha["default"])(codeVerifier)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, ''));
      }
    }, _callee19);
  }));
  return function generateCodeChallange(_x17) {
    return _ref20.apply(this, arguments);
  };
}();
var LocationType = exports.LocationType = {
  SIGN_IN: 'sign_in',
  SIGN_OUT: 'sign_out',
  RECOVERY_METHODS: 'recovery_methods'
};
function getUserManagerConfig(options) {
  var config = {};
  var mapping = {
    'authority': 'authority',
    'clientId': 'client_id',
    'clientSecret': 'client_secret',
    'redirectUri': 'redirect_uri',
    'responseType': 'response_type',
    'responseMode': 'response_mode',
    'scope': 'scope',
    'prompt': 'prompt',
    'display': 'display',
    'maxAge': 'max_age',
    'uiLocales': 'ui_locales',
    'loginHint': 'login_hint',
    'acrValues': 'acr_values',
    'clockSkew': 'clockSkew',
    'loadUserInfo': 'loadUserInfo',
    'filterProtocolClaims': 'filterProtocolClaims',
    'postLogoutRedirectUri': 'post_logout_redirect_uri',
    'popupRedirectUri': 'popup_redirect_uri',
    'popupWindowFeatures': 'popupWindowFeatures',
    'popupWindowTarget': 'popupWindowTarget',
    'silentRedirectUri': 'silent_redirect_uri',
    'automaticSilentRenew': 'automaticSilentRenew',
    'silentRequestTimeout': 'silentRequestTimeout',
    'accessTokenExpiringNotificationTime': 'accessTokenExpiringNotificationTime',
    'userStore': 'userStore',
    'monitorSession': 'monitorSession',
    'checkSessionInterval': 'checkSessionInterval',
    'revokeAccessTokenOnSignOut': 'revokeAccessTokenOnSignout',
    'includeIdTokenInSilentRenew': 'includeIdTokenInSilentRenew',
    'staleStateAge': 'staleStateAge',
    'extraQueryParams': 'extraQueryParams',
    'clientAuthentication': 'client_authentication'
  };
  Object.keys(mapping).forEach(function (key) {
    if (options[key] !== undefined) {
      config[mapping[key]] = options[key];
    }
  });
  return config;
}
function getExpiration(jwt) {
  if (!jwt) {
    return null;
  }
  return new Date((0, _jwtDecode["default"])(jwt).exp * 1000);
}
function base64Encode(str) {
  return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
    return String.fromCharCode('0x' + p1);
  }));
}
//# sourceMappingURL=auth.js.map